import { Directive, HostListener, ElementRef } from '@angular/core'

@Directive({ selector: '[selectonfocus]' })
export class SelectOnFocusDirective {
  constructor(private el: ElementRef) {}

  @HostListener('focus', ['$event.target'])
  onFocus(target: any) {
    this.el.nativeElement.select()
  }
}
